import styles from './Differentials.module.css';
import global from '../../styles/global.module.css';

import iconRocket from '../../assets/images/rocket 1.svg';
import iconFile from '../../assets/images/paper-file-text 1.svg';
import iconTools from '../../assets/images/tools-solid 1.svg';
import iconHandshake from '../../assets/images/handshake 1.svg';
import iconChat from '../../assets/images/chat-bubble 1.svg';
import iconCrosshair from '../../assets/images/crosshair 1.svg';

const DIFFERENTIALS = [
  {
    icon: iconRocket,
    title: 'Entrega ágil e personalizada',
    desc: 'Conteúdos sob medida e com rapidez. Acompanhando o ritmo da sua campanha.',
  },
  {
    icon: iconFile,
    title: 'Transparência total',
    desc: 'Oferecemos políticas claras, comunicação direta e sem surpresas no meio do caminho.',
  },
  {
    icon: iconTools,
    title: 'Gestão simples e eficiente',
    desc: 'Fluxos diretos, integrações que funcionam de verdade e acompanhamento profissional.',
  },
  {
    icon: iconHandshake,
    title: 'Parcerias confiáveis',
    desc: 'Trabalhamos com marcas conhecidas e validadas, conteúdos de alto valor percebido e alcance nacional.',
  },
  {
    icon: iconChat,
    title: 'Suporte humano e presente',
    desc: 'Atendimento real, direto e sempre disponível. Nada de respostas automáticas e genéricas.',
  },
  {
    icon: iconCrosshair,
    title: 'Estratégia e curadoria',
    desc: 'Cada uma das entregas é pensada com foco em impacto, engajamento e relevância para o seu público e seu objetivo.',
  },
];

export default function Differentials() {
  return (
    <section className={global.section, styles.backgroundWhite} id="diferenciais">
      <div className={styles.headerDifferentials}>
        <h2>Diferenciais</h2>
        <p>Combinamos tecnologia, curadoria e atendimento de verdade para transformar recompensas em experiências que funcionam. Atuamos com clareza, eficiência e compromisso para garantir que cada campanha ou benefício entregue valor real para sua empresa e seu público.
        </p>
      </div>
      <div className={styles.cardsWrapper}>
        {DIFFERENTIALS.map((item, i) => (
          <div className={styles.card} key={i}>
            <div className={styles.iconWrapper}>
              <img src={item.icon} alt="" aria-hidden="true" />
            </div>
            <div className={styles.textBlock}>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
